module.exports = __webpack_public_path__ + "img/login-min.e79aa3ea.png";